import script from "./StoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryView.vue?vue&type=script&setup=true&lang=js"

import "./StoryView.vue?vue&type=style&index=0&id=635e8d0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635e8d0d"]])

export default __exports__